import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';

const TrainingPost = ({ lesson, nextLesson, previousLesson, onNavigate }) => {
  const { frontmatter, content } = lesson;

  return (
    <article className="training-post">
      <header className="post-header">
        <div className="lesson-number">
          {frontmatter.lessonNumber && `Lesson ${frontmatter.lessonNumber}`}
        </div>
        <h1 className="post-title">{frontmatter.title}</h1>
      </header>

      <main className="post-content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            code({ node, inline, className, children, ...props }) {
              const match = /language-(\w+)/.exec(className || '');
              return !inline && match ? (
                <SyntaxHighlighter
                  style={tomorrow}
                  language={match[1]}
                  PreTag="div"
                  {...props}
                >
                  {String(children).replace(/\n$/, '')}
                </SyntaxHighlighter>
              ) : (
                <code className={className} {...props}>
                  {children}
                </code>
              );
            },
            h1: ({ children }) => <h1 className="content-h1">{children}</h1>,
            h2: ({ children }) => <h2 className="content-h2">{children}</h2>,
            h3: ({ children }) => <h3 className="content-h3">{children}</h3>,
            blockquote: ({ children }) => (
              <blockquote className="content-blockquote">{children}</blockquote>
            ),
            ul: ({ children }) => <ul className="content-list">{children}</ul>,
            ol: ({ children }) => <ol className="content-list">{children}</ol>,
            table: ({ children }) => <table className="content-table">{children}</table>,
            thead: ({ children }) => <thead className="content-table-head">{children}</thead>,
            tbody: ({ children }) => <tbody className="content-table-body">{children}</tbody>,
            tr: ({ children }) => <tr className="content-table-row">{children}</tr>,
            th: ({ children }) => <th className="content-table-header">{children}</th>,
            td: ({ children }) => <td className="content-table-cell">{children}</td>,
          }}
        >
          {content}
        </ReactMarkdown>
      </main>

      <nav className="post-navigation">
        <div className="nav-buttons">
          {previousLesson && (
            <button
              className="nav-button nav-previous"
              onClick={() => onNavigate(previousLesson.frontmatter.slug)}
            >
              <span className="nav-direction">← Previous</span>
              <span className="nav-title">
                Lesson {previousLesson.frontmatter.lessonNumber}
              </span>
            </button>
          )}
          
          {nextLesson && (
            <button
              className="nav-button nav-next"
              onClick={() => onNavigate(nextLesson.frontmatter.slug)}
            >
              <span className="nav-direction">Next →</span>
              <span className="nav-title">
                Lesson {nextLesson.frontmatter.lessonNumber}
              </span>
            </button>
          )}
        </div>
      </nav>
    </article>
  );
};

export default TrainingPost;